/* global axios */
import ApiClient from './ApiClient';

class HubAPI extends ApiClient {
  constructor() {
    super('tenant', { apiVersion: 'v1', accountScoped: true });
  }

  getTenant() {
    return axios.get(`${this.url}`);
  }
}

export default new HubAPI();
